module.exports = __webpack_public_path__ + "static/media/share.202befac.svg";